// Mirrors ORG_ROLES in backend-service/src/lib/auth-server.ts. better-auth
// stores Member.role as a string; this union is the app-level contract.
export const ORG_ROLES = ['admin', 'member'] as const;
export type OrgRole = (typeof ORG_ROLES)[number];

export function isOrgAdmin(role: string | null | undefined): boolean {
  return (role ?? '').split(',').includes('admin');
}
